<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-2">
          <h5 class="ma-0">Técnicos</h5>
        </div>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="platform in mappedTechnicians"
            :key="platform.id"
          >
            <v-expansion-panel-header class="gap-3">
              <div class="flex-grow-0">
                <v-img
                  :src="platform.logos.favicon"
                  :alt="platform.name"
                  width="35"
                  height="35"
                  class="rounded-xl"
                />
              </div>
              {{ platform.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <platform-technicians-management
                :platform="platform"
                :loading="loading"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
    <technician-member @success="getTechnicians" :platforms="platforms" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import TECHNICIANS from "@/services/admin/technicians";
import PLATFORMS from "@/services/admin/platform";

import TechnicianMember from "@/components/admin/modals/TechnicianMember.vue";
import PlatformTechniciansManagement from "@/components/admin/technicians/PlatformTechniciansManagement.vue";
import { decomposeToBitKeys } from "@/utils/permissionBits";

export default {
  components: {
    TechnicianMember,
    PlatformTechniciansManagement,
  },
  metaInfo: {
    title: "Técnicos",
  },
  data() {
    return {
      loading: false,
      technicians: [],
      platforms: [],
    };
  },
  methods: {
    ...mapActions("auth", ["getPermissions"]),

    edit(member) {
      this.$root.$emit("admin-member-modal", member);
    },
    async getPlatforms() {
      try {
        this.loading = true;
        var response = await PLATFORMS.getAll();
        this.platforms = response.platforms.filter(({ active }) => active);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getTechnicians() {
      try {
        this.loading = true;
        var response = await TECHNICIANS.getAll();
        this.technicians = response.masterPermissions.map((u) => ({
          ...u,
          permissions: decomposeToBitKeys(u.permission),
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    numberOfPages() {
      return Math.ceil(this.technicians.length / this.itemsPerPage);
    },
    mappedTechnicians() {
      return this.platforms.map((p) => ({
        ...p,
        technicians: this.technicians.filter((t) => t.platformId === p.id),
      }));
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.platforms = [];
      this.technicians = [];
      this.getPlatforms();
      this.getTechnicians();
    },
  },
  async mounted() {
    await this.getPlatforms();
    await this.getTechnicians();
  },
};
</script>
